import {
  deleteSignalRRecoveryState,
  getSignalRRecoveryState,
  setSignalRRecoveryState,
} from '~/services/localStorage/signalr';

const SIGNALR_RECOVERY_COOLDOWN_MS = 15000;

const shouldRecoverSignalR = (tabId: string): boolean => {
  const now = Date.now();
  const cachedValue = getSignalRRecoveryState();

  if (cachedValue) {
    try {
      const { owner, updatedAt } = cachedValue;

      if (owner !== tabId && updatedAt && now - updatedAt < SIGNALR_RECOVERY_COOLDOWN_MS) {
        return false;
      }
    } catch {
      deleteSignalRRecoveryState();
    }
  }

  setSignalRRecoveryState({
    owner: tabId,
    updatedAt: now,
  });

  return true;
};

export default shouldRecoverSignalR;
